interface ExtendedFilterPlugin {
  fn: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    opsFilter: (taggedOps: any, phrase: string) => any;
  };
}
const caseInsensitiveContains = function (a: string, b: string): boolean {
  return a.toLowerCase().indexOf(b.toLowerCase()) !== -1;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const childMatch = function (tagObj: any, phrase: string): boolean {
  return tagObj.get('operations').some(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (operationObj: any) =>
      caseInsensitiveContains(operationObj.get('operation').get('summary'), phrase) ||
      caseInsensitiveContains(operationObj.get('operation').get('description'), phrase)
  );
};

export default function ExtendedFilterPlugin(): ExtendedFilterPlugin {
  // This plugin makes the filter search bar case insensitive + searches descriptions of tags and operations.
  return {
    fn: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      opsFilter: (taggedOps: any, phrase: string) =>
        taggedOps.filter(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (tagObj: any, tag: string) =>
            caseInsensitiveContains(tag, phrase) ||
            childMatch(tagObj, phrase) ||
            (tagObj.get('tagDetails') &&
              caseInsensitiveContains(tagObj.get('tagDetails').get('description'), phrase))
        ),
    },
  };
}
